import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { MachineModuleService } from '../../../shared/services';
import { Machine } from '../../../shared/models';
import * as _ from 'lodash';

@Component({
  templateUrl: './edit-machine-page.component.html',
  standalone: false
})
export class EditMachinePageComponent extends BaseModalPageComponent implements OnInit {
  public processing = false;
  public machine: Machine;
  public productLines: any = [];
  public models: any = [];

  constructor(location: Location, private router: Router, private route: ActivatedRoute, private machinesService: MachineModuleService) {
    super(location);
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const machineSerial = params['machineSerial'];
      this.machinesService.getMachine(machineSerial).subscribe((machine) => {
        this.machine = machine;
      });
    });
  }

  update(machine: Machine): void {
    this.processing = true;
    this.machinesService.updateMachine(this.machine.serialNumber, machine).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  goToBack() {
    this.router.navigate([this.appRoute, 'machines', this.machine.serialNumber]);
  }
}
